// extracted by mini-css-extract-plugin
module.exports = {"root":"_068cdb","title":"_d23196"};